import * as z from 'zod/v4';
import { EnumParams } from '../events.types';
import { MODES_REQUIRING_ELEMENT } from './combat-consts';

export const REWARD_SOURCE_VALUES = ['BattleGameMode', 'Patrol'] as const;

const rewardListRowSchema = (enums?: EnumParams) =>
  z
    .object({
      allResources: z.boolean().optional(),
      allGear: z.boolean().optional(),
      resource: enums ? z.enum(enums.ResourceType).optional() : z.string().optional(),
      gear: enums ? z.enum(enums.GearType).optional() : z.string().optional(),
      resourceCategory: enums ? z.enum(enums.ResourceCategory).optional() : z.string().optional(),
      gearRarity: enums ? z.enum(enums.Rarity).optional() : z.string().optional(),
    })
    .refine(
      row => {
        const count = [
          row.allResources !== undefined,
          row.allGear !== undefined,
          row.resource !== undefined,
          row.gear !== undefined,
          row.resourceCategory !== undefined,
          row.gearRarity !== undefined,
        ].filter(Boolean).length;
        return count === 1;
      },
      { message: 'Exactly one reward filter must be set per row' },
    );

export const increasedRewardsSectionSchema = (enums?: EnumParams) =>
  z
    .object({
      multiplier: z.number().gt(0).lte(10),
      rewardSource: z.enum(REWARD_SOURCE_VALUES),
      gameMode: enums ? z.enum(enums.GameMode).optional() : z.string().optional(),
      element: enums ? z.enum(enums.CombatTag).optional() : z.string().optional(),
      rewardWhiteList: z.array(rewardListRowSchema(enums)),
      rewardBlackList: z.array(rewardListRowSchema(enums)),
    })
    .refine(
      data => {
        if (data.rewardSource === 'BattleGameMode') return data.gameMode !== undefined;
        return data.gameMode === undefined;
      },
      {
        message: 'GameMode is required when RewardSource is BattleGameMode',
        path: ['gameMode'],
      },
    )
    .refine(
      data => {
        if (data.gameMode === undefined) return data.element === undefined;
        const requiresElement = (MODES_REQUIRING_ELEMENT as readonly string[]).includes(
          data.gameMode,
        );
        return requiresElement ? data.element !== undefined : data.element === undefined;
      },
      {
        message:
          'Element is required for DailyDungeon/GuildBoss modes, and must be absent otherwise',
        path: ['element'],
      },
    );
